/* eslint-disable sonarjs/no-duplicate-string */
import configs from '@/config'

const localData = {
  en: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 126,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/quiz.webm`,
      language: 'en',
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 126,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 81,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 126,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 126,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  vi: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 153,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/quiz.webm`,
      language: 'en',
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 153,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 82,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 153,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 153,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  fr: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 154,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/quiz.webm`,
      language: 'en',
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 154,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 154,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 154,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 154,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  es: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 155,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/quiz.webm`,
      language: 'en',
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 155,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 155,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 155,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 155,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  zh: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 156,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/quiz.webm`,
      language: 'en',
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 156,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 156,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 156,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 156,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  ru: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 157,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/quiz.webm`,
      language: 'en',
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 157,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 157,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 157,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 157,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
}

const developData = {
  en: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 52073,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 52074,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 52075,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 52076,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 52077,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  vi: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 52679,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 52679,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 52679,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 52679,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 52679,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  fr: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 52678,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 52678,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 52678,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 52678,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 52678,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  es: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 52681,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 52681,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 52681,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 52681,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 52681,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  zh: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 52682,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 52682,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 52682,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 52682,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 52682,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  ru: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 52683,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 52683,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 52683,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 52683,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 52683,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
}

const productionData = {
  en: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 5825890,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 5825912,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 5825926,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 5825923,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 5825918,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/en/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  vi: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 5902296,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 5902305,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 5902308,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 5902309,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 5901957,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/vi/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  fr: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 5901697,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 5901788,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 5901659,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 5901756,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 5901776,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/fr/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  es: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 5902328,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 5902329,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 5902331,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 5902333,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 5902335,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/es/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  zh: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 5902337,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 5902338,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 5902339,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 5902344,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 5902345,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/zh/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
  ru: [
    {
      key: 'quiz',
      name: 'Quiz',
      presentationId: 5902260,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/quiz.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'poll',
      name: 'Poll',
      presentationId: 5902262,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/poll.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'wordCloud',
      name: 'Word Cloud',
      presentationId: 5902261,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/word-cloud.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'spinnerWheel',
      name: 'Spinner Wheel',
      presentationId: 5902266,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/spinner-wheel.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
    {
      key: 'qna',
      name: 'Q&A',
      presentationId: 5901808,
      previewSource: `${configs.cloudfrontPublic}/feature-based-options/ru/qna.webm`,
      useAhaSlidesFor: 'Business',
      userProfession: 'Trainer / L&D',
    },
  ],
}

const getOnboardingTemplatesByEnv = (env) => {
  switch (env) {
    case 'local':
      return localData
    case 'develop':
      return developData
    case 'production':
      return productionData
    default:
      return null
  }
}

const getMockData = (dataByEnv, language) => {
  const data = dataByEnv[language]

  if (!data) {
    throw new Error('Unknown language')
  }

  return data
}

const getDataForEnv = (language) => {
  let data = null

  switch (configs.env) {
    case 'local':
      data = getMockData(localData, language)
      break
    case 'develop':
      data = getMockData(developData, language)
      break
    case 'production':
      data = getMockData(productionData, language)
      break
    default:
      throw new Error('Unknown environment')
  }

  return data
}

const applyFeatureIcons = (data, featureIconMap) => {
  return data.map((item) => ({
    ...item,
    icon: featureIconMap[item.key] || null,
  }))
}

const delayResolve = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(data), 0)
  })
}

export const mockDataResponse = async (params) => {
  const { language } = params
  let data = getDataForEnv(language)

  // Icon map for the V1 response
  const featureIconMap = {
    quiz: 'trophy-colored',
    poll: 'poll-colored',
    wordCloud: 'cloud-colored',
    spinnerWheel: 'spinner-wheel-colored',
    qna: 'qna-colored',
  }

  data = applyFeatureIcons(data, featureIconMap)

  return delayResolve(data)
}

export const mockDataResponseV2 = async (params) => {
  const { language } = params
  let data = getDataForEnv(language)

  // Filter out spinnerWheel and qna for V2
  data = data.filter((item) => item.key !== 'spinnerWheel' && item.key !== 'qna')

  // Icon map for the V2 response
  const featureIconMap = {
    quiz: 'trophy-colored',
    poll: 'poll-colored',
    wordCloud: 'cloud-colored',
  }

  data = applyFeatureIcons(data, featureIconMap)

  return delayResolve(data)
}

// AHA-33161: check for presentation that cloned from onboarding template
// The goal is prevent loading new Component that utilize data from ahaSync

export const isClonedFromOnboardingTemplate = (presentation, locale, env) => {
  const sourcePresentationId = presentation.sourcePresentation

  if (!sourcePresentationId) return false
  const onboardingTemplates = getOnboardingTemplatesByEnv(env)
  if (!onboardingTemplates) return false
  const templatesByLanguage = onboardingTemplates[locale]
  if (!templatesByLanguage) return false

  return templatesByLanguage?.map((i) => i.presentationId)?.includes(sourcePresentationId)
}

export default mockDataResponse
